import React from "react";
import { Navigate, useRoutes } from "react-router";
import AdminPanelLayout from "../components/admin-panel/admin-panel-layout";
import Login from "../pages/authentication/Login";
import User from "../pages/User/User";
import UserDetails from "../pages/User/UserDetails";
import Jobs from "../pages/jobs/Jobs";
import JobDetails from "../pages/jobs/JobDetails";
import MapLimit from "../pages/maplimit/maplimit";
import JobReport from "../pages/report/jobreport";

export const PrivateRoute = ({ children }) => {
  const user = localStorage.getItem("admin_store");
  return user ? children : <Navigate to="/login" />;
};

export const PublicRoute = ({ children }) => {
  const user = localStorage.getItem("admin_store");
  return user ? <Navigate to="/" /> : children;
};

// const Routes = () => {
//   return useRoutes([
//     {
//       path: "/",
//       element: (
//         <PrivateRoute>
//           <AdminPanelLayout />
//         </PrivateRoute>
//       ),
//       children: [
//         {
//           path: "/",
//           element: <Dashboard />,
//         },
//       ],
//     },
//     {
//       path: "/login",
//       element: (
//         <PublicRoute>
//           <Login />
//         </PublicRoute>
//       ),
//     },
//   ]);
// };

const routes = (isLoggedIn) => [
  {
    path: "/login",
    element: !isLoggedIn ? <Login /> : <Navigate to="/" />,
  },
  {
    path: "/",
    element: isLoggedIn ? <AdminPanelLayout /> : <Navigate to="/login" />,
    children: [
      {
        element: <User />,
        path: "/",
        index: true,
      },
      {
        element: <User />,
        path: "/users",
      },
      {
        element: <UserDetails />,
        path: "/users/:userId",
      },
      {
        element: <Jobs />,
        path: "/jobs",
      },
      {
        element: <JobDetails />,
        path: "/jobs/:jobId",
      },
      {
        element: <MapLimit />,
        path: "/maplimit",
      },
      {
        element: <JobReport />,
        path: "/jobreport",
      },
    ],
  },
];

export default function Routes(props) {
  const { isLoggedIn } = props;
  return useRoutes(routes(isLoggedIn));
}
